<div class="dashboard-container mb-4 mx-lg-4 mx-md-3 pt-2">
	<h5 class="fw-bold mb-3 mb-md-4">{{ greeting() }}</h5>

	@switch (viewMode()) {
		@case (DashboardViewMode.Loading) {
			<div class="d-flex justify-content-center align-items-center py-5">
				<div class="spinner-border text-primary" role="status">
					<span class="visually-hidden">Loading dashboard...</span>
				</div>
			</div>
		}
		@case (DashboardViewMode.Staff) {
			<ms-staff-dashboard />
		}
		@case (DashboardViewMode.OrgMember) {
			<ms-org-dashboard />
		}
		@case (DashboardViewMode.NoActiveOrganizations) {
			<ms-dashboard-no-active-org-prompt />
		}
	}
</div>
